import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Compass } from "lucide-react";
import { LiveTour, useTourDone } from "@/components/LiveTour";

const TOTAL = 4;

// Steps 1-2 on the Live list; shows once automatically for members who haven't finished or skipped it.
export const ListTour = ({ rows }) => {
  const nav = useNavigate();
  const { ready, done, finish } = useTourDone();
  const [on, setOn] = useState(false);
  const country = rows?.find((ev) => ev.brief_kind === "country");
  useEffect(() => { if (ready && !done && country) setOn(true); }, [ready, done, !!country]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!country) return null;
  const steps = [
    { sel: '[data-testid="live-heart"]', title: "Welcome to Middle Live", text: "The heart of Middle: what is known, what isn't yet, and where it came from. No extra opinions, just the verified record." },
    { sel: `[data-testid="live-card-perspective-link-${country.id}"]`, title: "Find the middle on election issues", text: "Each country's Trending political issues page shows both sides of the topics that may decide its next election, and Middle's evidence-first view.", cta: "Show me", next: () => nav(`/live/${country.id}?tab=perspective&tour=2`) },
  ];
  return (<>
    <button type="button" onClick={() => setOn(true)} className="inline-flex items-center gap-1.5 text-sm font-medium text-[hsl(var(--facts))] hover:underline" data-testid="live-tour-start"><Compass size={15} />Take the tour</button>
    {on && <LiveTour steps={steps} total={TOTAL} onDone={() => { setOn(false); finish(); }} />}
  </>);
};

// Steps 3-4 on the country page the tour opened.
export const DetailTour = () => {
  const [params, setParams] = useSearchParams();
  const { finish } = useTourDone();
  if (params.get("tour") !== "2") return null;
  const end = () => { const p = new URLSearchParams(params); p.delete("tour"); setParams(p, { replace: true }); finish(); };
  const steps = [
    { sel: '[data-testid="topic-chips"]', title: "Jump to any topic", text: "Tap a topic to go straight to Middle's perspective on it. The 'Middle's perspective' button at the top always brings you here." },
    { sel: '[data-testid="topic-middle-0"]', title: "Middle's perspective", text: "What the record shows, where both sides agree, the real trade-offs and what's still unknown. Tap 'Alert me when this changes' to hear when new facts change it." },
  ];
  return <LiveTour steps={steps} offset={2} total={TOTAL} onDone={end} />;
};
